const Hero = () => {
  return (
    <div className="hero">
      <h1>Something about our Hotel Website</h1>
      <p>You can enjoy stay a night for free</p>
    </div>
  );
};

export default Hero;
